










import { Component } from 'vue-property-decorator';

import DialogBase from '@/components/common/DialogBase';
import FeedbackCard from '@/components/FeedbackCard.vue';

@Component({
  components: {
    FeedbackCard,
  },
})
export default class FeedbackDialog extends DialogBase {}
